import {useValidations} from '@sttedra_ui/framework';

const {required} = useValidations();

export default {
  url: {
    required,
  },
  nameService: {
    required,
  },
  format: {
    required,
  },
};
